import TableView from "../components/TableView";
import React, {useEffect, useState} from "react";
import {ConfirmDialog, confirmDialog} from "primereact/confirmdialog";
import {useOutletContext} from "react-router-dom";
import {Button} from "primereact/button";
import {Dialog} from "primereact/dialog";
import {useFormik} from "formik";
import FormGroup from "../components/FormGroup";
import {InputText} from "primereact/inputtext";
import {Dropdown} from "primereact/dropdown";
import {InputNumber} from "primereact/inputnumber";
import {InputTextarea} from "primereact/inputtextarea";
import {DepartmentService} from "../services/DepartmentService";

function DepartmentAdditional() {

    const context = useOutletContext()

    const [loading, setLoading] = useState(true)
    const [dialogVisible, setDialogVisible] = useState(false)

    const [additionals, setAdditionals] = useState([])
    const [individuals, setIndividuals] = useState([])

    const tableRows = [
        {label: 'Название', name: 'name', selected: true}
    ];

    useEffect(() => {
        context.setActiveTab('additional')
        setAdditionals(context.additionals.filter((el) => el.type === 'additional'))
        setIndividuals(context.additionals.filter((el) => el.type === 'individual'))
        setLoading(false)
    }, [context]);

    const handleEditItem = (e) => {

    }


    const rowActions = [
        {
            'label': 'Редактировать',
            icon: 'pi pi-pencil',
            command: (e) => {

                additionalForm.setValues([...additionals, ...individuals].find((el) => el.id === e.item.rowId))
                setDialogVisible(true)
                // navigation('/departments/' + e.item.rowId)
            }
        },
        {
            'label': 'Удалить',
            icon: 'pi pi-trash',
            command: (e) => {

                confirmDialog({
                    message: 'Вы хотите удалить этот предмет?',
                    header: 'Подтвердите удаление',
                    icon: 'pi pi-info-circle',
                    acceptClassName: 'p-button-danger',
                    accept: () => {
                        setLoading(true)
                        DepartmentService.deleteAdditional(e.item.rowId).then(() => {
                            context.updateData()
                        })
                    },
                    acceptLabel: 'Да',
                    reject: () => {
                        return false
                    },
                    rejectLabel: 'Нет'
                });
            }
        }
    ];

    const handlerRawActions = (elId) => {

        const currentRow = [...additionals, ...individuals].find((el) => {
            return el.id === elId
        })


        if(currentRow) {
            rowActions.map((actionRow, k) => {
                actionRow.rowId = elId
            })
            return rowActions;
        }
    }

    const addAdditionalHandler = (type) => {
        additionalForm.resetForm()
        additionalForm.setFieldValue('type', type, false)
        setDialogVisible(true)
    }

    const additionalForm = useFormik({
        initialValues: {
            name: ''
        },
        validate: (data) => {
            let errors = {}

            if(!data.name){
                errors.name = 'Укажите название'
            }

            if(!data.type){
                errors.name = 'Укажите тип'
            }

            return errors
        },
        onSubmit: (data) => {
            setLoading(true)
            data.department_id = context.id
            data.base_price = data.base_price.toString()

            if(data.id) {
                DepartmentService.updateAdditional(data).then((result) => {
                    context.updateData()
                    setDialogVisible(false)
                })
            } else {
                DepartmentService.addAdditional(data).then((result) => {
                    context.updateData()
                    setDialogVisible(false)
                })
            }
        }
    })

    return (
        <>

            <ConfirmDialog/>
            <Dialog header={'Добавление/редактирование предмета'} style={{width: '400px'}} onHide={() => setDialogVisible(false)} visible={dialogVisible}>
                <form className={'edit-department'} onSubmit={additionalForm.handleSubmit}>
                    <FormGroup label={'Наименование'} error={additionalForm.errors.name}>
                        <InputText value={additionalForm.values.name} onChange={(e) => additionalForm.setFieldValue('name', e.target.value)} autoFocus/>
                    </FormGroup>

                    <FormGroup label={'Тип'}>
                        <Dropdown options={[
                            {label: 'Дополнительный', value: 'additional'},
                            {label: 'Индивидуальный', value: 'individual'},
                        ]} value={additionalForm.values.type} onChange={(e) => additionalForm.setFieldValue('type', e.value)}/>
                    </FormGroup>


                    <FormGroup label={'Стоимость 1 занятия'}>
                        <InputNumber mode={'currency'} value={additionalForm.values.base_price} onChange={(e) => additionalForm.setFieldValue('base_price', e.value)} currency={'RUB'}/>
                    </FormGroup>

                    <FormGroup label={'Описание'}>
                        <InputTextarea autoResize={true} row={5} value={additionalForm.values.text} onChange={(e) => additionalForm.setFieldValue('text', e.target.value)}/>
                    </FormGroup>


                    <Button loading={loading} type={'submit'} label={'Сохранить'}/>
                </form>
            </Dialog>


            <div className="row">
                <div className="col-lg-5">
                    <div className="card project-list">
                        <div className="card-body">
                            <div className="d-flex align-items-center justify-content-between m-b-30">
                                <h3 className={''}>Дополнительные </h3>
                                <Button icon={'pi pi-plus'} label={'Добавить'} className={'p-button-sm p-button-success'} onClick={(e) => addAdditionalHandler('additional')}/>
                            </div>
                            <TableView id={'additional-list'} tableRows={tableRows} data={{items: additionals}}
                                       loading={loading}
                                       setTableRows={(data) => setAdditionals(data)} handleEdit={handleEditItem}
                                       rowActions={rowActions} massRowActions={false} massActionHander={false}
                                       rowActionsHandler={handlerRawActions} tableClass={'departments-table'}
                                       hideHead={true} hideSettings={true}/>

                        </div>
                    </div>
                </div>
                <div className="col-lg-5">
                    <div className="card project-list">
                        <div className="card-body">
                            <div className="d-flex align-items-center justify-content-between m-b-30">
                                <h3 className={''}>Индивидуальные </h3>
                                <Button icon={'pi pi-plus'} label={'Добавить'} className={'p-button-sm p-button-success'}  onClick={(e) => addAdditionalHandler('individual')}/>
                            </div>
                            <TableView id={'additional-list'} tableRows={tableRows} data={{items: individuals}}
                                       loading={loading}
                                       setTableRows={(data) => setIndividuals(data)} handleEdit={handleEditItem}
                                       rowActions={rowActions} massRowActions={false} massActionHander={false}
                                       rowActionsHandler={handlerRawActions} tableClass={'departments-table'}
                                       hideSettings={true} hideHead={true}/>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )

}

export default DepartmentAdditional